import {
  Container,
  makeStyles,
  Grid,
  useTheme,
  useMediaQuery,
  Box,
  Card,
  Link as MuiLink,
  TextField,
} from '@material-ui/core'
import Head from 'next/head'
import clsx from 'clsx'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Layout from '../components/common/Layout'
import ButtonSp from '../components/ui/ButtonSp'
import ProtectedByRecaptcha from '../components/common/ProtectedByRecaptcha'
import GetStarted from '../components/home/GetStarted'
import { scroller } from 'react-scroll'
import { useForm, Controller } from 'react-hook-form'
import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import getConfig from 'next/config'
import Axios from 'axios'
import SuccessModal from '../components/common/SuccessModal'
import LazyLoad from 'react-lazyload'
import LazyloadPlaceholder from '../components/ui/LazyloadPlaceholder'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ApiCustomers from '../components/for-developers/ApiCustomers'
import ContactDevModal from '../components/for-developers/ContactDevModal'
import ApplyResultModal from '../components/for-developers/ApplyResultModal'
import MailIcon from '@material-ui/icons/Mail'

const { publicRuntimeConfig } = getConfig()

const usingContactDevForm = false

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    width: '100vw',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  section: {
    width: '100%',
    padding: theme.homeStyle.sectionPadding,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  sectionWithoutHorizontalPadding: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  heroImage: {
    background:
      'linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0,0,0,0)),url("/static/img/for-developers/for-developers-hero.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: theme.homeStyle.heroImageHeightDesktop,
    backgroundColor: 'black',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.only('sm')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      height: theme.homeStyle.heroImageHeightMobile,
      background:
        'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%),url("/static/img/for-developers/for-developers-hero-mobile.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: `${theme.spacing(2)}px 0`,
    },
  },
  heroText: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '40%',
    },
    [theme.breakpoints.only('sm')]: {
      maxWidth: '60%',
    },
  },
  heroTitle: {
    ...theme.homeStyle.heroTitle,
  },
  heroSubtitle: {
    ...theme.homeStyle.heroSubtitle,
  },
  textAlignLeft: {
    textAlign: 'left !important',
  },
  title: {
    ...theme.homeStyle.title,
  },
  subtitle: {
    ...theme.homeStyle.subtitle,
  },
  titleWithSubtitle: {
    marginBottom: 0,
  },
  bodyText: {
    ...theme.homeStyle.desc,
  },
  button: {
    ...theme.homeStyle.button,
    [theme.breakpoints.down('xs')]: {
      margin: `${theme.spacing(1)}px 0`,
    },
  },
  horizontalSpace2: {
    width: theme.spacing(2),
  },
  verticalSpacer2: {
    height: theme.spacing(2),
  },
  pluginGridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  featureCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    padding: theme.spacing(3),
    ...theme.homeStyle.boxShadow,
    borderRadius: 8,
    textAlign: 'center',
    '& > img': {
      height: 60,
      width: 60,
    },
    '& > h4': {
      ...theme.homeStyle.topic,
      marginBottom: 0,
    },
    '& > p': {
      ...theme.homeStyle.desc,
    },
  },
  pluginCard: {
    width: 300,
    height: 260,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    border: '1px solid #E0E0E0',
    padding: theme.spacing(2),
    '& > img': {
      maxWidth: '100%',
    },
  },
  customer: {
    height: 100,
    padding: theme.spacing(3),
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  greySection: {
    backgroundColor: '#FAFAFA',
    marginTop: theme.spacing(5),
  },
  noMarginBottom: {
    marginBottom: '0 !important',
  },
  whiteBrackgroundButton: {
    backgroundColor: 'white',
  },
  topic: {
    ...theme.homeStyle.topic,
    fontSize: 18,
  },
  apiManualButton: {
    ...theme.homeStyle.boxShadow,
    borderRadius: 8,
    padding: theme.spacing(1),
    height: '100%',
  },
  noMargin: {
    margin: 0,
  },
  apiManualButtonText: {
    textAlign: 'left !important',
    marginLeft: theme.spacing(1),
  },
  postmanBgColor: {
    backgroundColor: '#FD6C35',
  },
  colorWhite: {
    color: 'white',
  },
  topicApiManualButton: {
    width: '100%',
    textAlign: 'center',
  },
}))

const ForDeveloperPage = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))
  const isDesktop = !isMobile && !isTablet
  const { t, i18n } = useTranslation('for-developers')
  const tTh = i18n.getFixedT('th', 'for-developers')

  const scrollToForm = () => {
    scroller.scrollTo('api-partner-form', {
      smooth: 'easeInOutQuart',
      offset: -100,
    })
  }

  const scrollToManual = () => {
    scroller.scrollTo('api-manual-section', {
      smooth: 'easeInOutQuart',
      offset: -100,
    })
  }

  // v About form
  const { control, handleSubmit, errors } = useForm()
  const [isFormExecuting, setFormExecuting] = useState(false)
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false)
  const [isErrorModalOpen, setErrorModalOpen] = useState(false)
  const [isApplyFailModalOpen, setApplyFailModalOpen] = useState(false)
  const [submittedEmail, setSubmittedEmail] = useState('')
  const [isContactDevelopModalOpen, setContactDeveloperModalOpen] =
    useState(false)
  const recaptchaRef = useRef(null)

  const onFormSubmit = handleSubmit(async (data) => {
    try {
      setFormExecuting(true)
      const token = await recaptchaRef.current.executeAsync()
      const {
        data: { success: captchaSuccess },
      } = await Axios.post('/api/recaptcha/validate', { recaptchaToken: token })
      if (captchaSuccess) {
        const res = await Axios.post('/api/api-partner/apply', data)
        if (res.data.status === 'success') {
          const apiKey =
            res.data.response &&
            res.data.response.data &&
            res.data.response.data.api_key
          if (apiKey === null || apiKey === undefined) {
            setSubmittedEmail(data.email)
            setApplyFailModalOpen(true)
          } else {
            setSubmittedEmail(data.email)
            setSuccessModalOpen(true)
          }
        } else setErrorModalOpen(true)
      }
    } catch (err) {
      setErrorModalOpen(true)
    } finally {
      setFormExecuting(false)
      recaptchaRef.current.reset()
    }
  })

  const renderHeroImageSection = () => (
    <div className={classes.heroImage}>
      <Container maxWidth="lg">
        <div className={classes.heroText}>
          <h1 className={classes.heroTitle}>{t('hero.title')}</h1>
          <h2 className={classes.heroSubtitle}>{t('hero.subtitle')}</h2>
        </div>
      </Container>
    </div>
  )

  const renderApiDescription = () => (
    <div className={classes.apiDescriptionArea}>
      <h2 className={clsx(classes.title, classes.textAlignLeft)}>
        {t('api-desc.title')}
      </h2>
      <p className={clsx(classes.bodyText, classes.textAlignLeft)}>
        {t('api-desc.desc1')}
      </p>
      <div className={classes.verticalSpacer2} />
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
        <ButtonSp
          className={classes.button}
          fullWidth={isMobile}
          component="a"
          onClick={scrollToForm}
        >
          {t('api-desc.get-api')}
        </ButtonSp>
        {!isMobile && <div className={classes.horizontalSpace2} />}
        <ButtonSp
          className={classes.button}
          variant="outlined"
          fullWidth={isMobile}
          component="a"
          onClick={scrollToManual}
        >
          {t('api-desc.documentation')}
        </ButtonSp>
      </Box>
    </div>
  )

  const apiFeatures = [
    ['api-checkprice.svg', t('api-checkprice.title'), t('api-checkprice.desc')],
    [
      'api-create-order.svg',
      t('api-create-order.title'),
      t('api-create-order.desc'),
    ],
    ['api-print.svg', t('api-print.title'), t('api-print.desc')],
    ['api-tracking.svg', t('api-tracking.title'), t('api-tracking.desc')],
  ].map((list) => ({ img: list[0], title: list[1], desc: list[2] }))

  const renderApiFeatures = () => (
    <div className={classes.apiFeaturesArea}>
      <Grid container spacing={2}>
        {apiFeatures.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            key={index}
            className={classes.featureGridItem}
          >
            <Card elevation={0} className={classes.featureCard}>
              <img
                src={`/static/img/for-developers/${feature.img}`}
                alt={feature.title}
              />
              <h4>{feature.title}</h4>
              <p>{feature.desc}</p>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  )

  const renderApiSection = () => (
    <div className={classes.section}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            {renderApiDescription()}
          </Grid>
          <Grid item xs={12} md={6}>
            {renderApiFeatures()}
          </Grid>
        </Grid>
      </Container>
    </div>
  )

  const shippopPlugins = [
    [
      'woocommerce.png',
      null,
      <MuiLink
        href="/static/files/for-developers/SHIPPOP_WooCommerce_manual.pdf"
        target="_blank"
      >
        {t('manual-for')} WooComerce {'>'}
      </MuiLink>,
      'Woo Commerce',
      'https://wordpress.org/plugins/shippop-ecommerce/',
    ],
    [
      'magento.svg',
      null,
      <MuiLink
        href="/static/files/for-developers/SHIPPOP_Magento_manual.pdf"
        target="_blank"
      >
        {t('manual-for')} Magento {'>'}
      </MuiLink>,
      'Magento',
      'https://marketplace.magento.com/shippop-magento2-ecommerce.html',
    ],
    ['widget.svg', 'Widget SHIPPOP', null, 'SHIPPOP Widget', '/widget'],
  ].map((list) => ({
    img: list[0],
    name: list[1],
    link: list[2],
    alt: list[3],
    imgLink: list[4],
  }))

  const renderPluginSection = () => (
    <div className={classes.section}>
      <Container>
        <h2 className={clsx(classes.title, classes.titleWithSubtitle)}>
          {t('plugin.title')}
        </h2>
        <h2 className={classes.subtitle}>{t('plugin.subtitle')}</h2>
        <Grid container direction={isMobile ? 'column' : 'row'} spacing={2}>
          {shippopPlugins.map((plugin, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              className={classes.pluginGridItem}
            >
              <Box
                component="a"
                href={plugin.imgLink}
                target={plugin.imgLink.startsWith('/') ? '_self' : '_blank'}
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                className={classes.pluginCard}
              >
                <img
                  src={`/static/img/for-developers/${plugin.img}`}
                  alt={plugin.alt}
                />
                {plugin.name && <p>{plugin.name}</p>}
              </Box>
              {plugin.link && (
                <>
                  <div className={classes.verticalSpacer2} />
                  {plugin.link}
                  <div className={classes.verticalSpacer2} />
                </>
              )}
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  )

  const renderApiManualButton = (imgSrc, label, href, isPostman = false) => (
    <a href={href} target="_blank">
      <Card
        elevation={0}
        className={clsx(
          classes.apiManualButton,
          isPostman && classes.postmanBgColor
        )}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          height="100%"
        >
          <Box display="flex" flexDirection="column" width="100%">
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
            >
              <img
                src={imgSrc}
                alt={label}
                style={{ width: 50, height: 50, margin: theme.spacing(1) }}
              />
              <h4
                className={clsx(
                  classes.topic,
                  classes.noMargin,
                  isPostman && classes.colorWhite,
                  classes.topicApiManualButton
                )}
              >
                {label}
              </h4>
            </Box>
          </Box>
          <ChevronRightIcon color={isPostman ? 'secondary' : 'action'} />
        </Box>
      </Card>
    </a>
  )

  const renderApiManualBottomPart = () => (
    <>
      <div className={classes.verticalSpacer2} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {renderApiManualButton(
            '/static/img/for-developers/shippop-api.svg',
            t('api-manual.shippop-api'),
            'http://developers.shippop.com/seller'
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {renderApiManualButton(
            '/static/img/for-developers/postman-icon.png',
            t('api-manual.log-info-api'),
            publicRuntimeConfig.postmanURL,
            true
          )}
        </Grid>
      </Grid>
      <div className={classes.verticalSpacer2} />
      <p className={clsx(classes.bodyText, classes.textAlignLeft)}>
        {t('api-manual.more-infomation')}{' '}
        {usingContactDevForm ? (
          <MuiLink
            onClick={() => setContactDeveloperModalOpen(true)}
            style={{
              whiteSpace: 'nowrap',
            }}
          >
            <MailIcon style={{ marginBottom: -4, marginRight: 4 }} />
            {t('api-manual.contact-our-team')}
          </MuiLink>
        ) : (
          <MuiLink href="mailto:dev@shippop.com" target="_blank">
            dev@shippop.com
          </MuiLink>
        )}
      </p>
    </>
  )

  const renderApiManualSection = () => (
    <div className={clsx(classes.section, classes.greySection)}>
      <Container>
        <Grid container direction={isMobile ? 'column' : 'row-reverse'}>
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img
              src="/static/img/for-developers/api-manual.svg"
              alt="SHIPPOP Api"
              style={{
                maxWidth: '100%',
                marginTop: -70,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <h2
              className={clsx(
                classes.title,
                classes.textAlignLeft,
                classes.noMarginBottom
              )}
            >
              {t('api-manual.title')}
            </h2>
            <p className={clsx(classes.bodyText, classes.textAlignLeft)}>
              {t('api-manual.desc')}
            </p>
            {!isTablet && renderApiManualBottomPart()}
          </Grid>
          {isTablet && (
            <Grid item xs={12} container direction="column" alignItems="center">
              {renderApiManualBottomPart()}
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  )

  const renderFormSection = () => (
    <div className={classes.section} id="api-partner-form">
      <Container
        maxWidth="md"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        component="form"
        onSubmit={onFormSubmit}
      >
        <h2 className={clsx(classes.title, classes.titleWithSubtitle)}>
          {t('form.title')}
        </h2>
        <h2 className={classes.subtitle}>{t('form.subtitle')}</h2>
        <Grid container spacing={2}>
          {[
            [
              'companyName',
              t('form.company-name'),
              t('form.company-name-p'),
              'text',
              {},
              '',
            ],
            [
              'nameSurname',
              t('form.name-surname'),
              t('form.name-surname-p'),
              'text',
              { required: true },
              t('form.error.name-required'),
            ],
            [
              'phone',
              t('form.phone'),
              t('form.phone-p'),
              'number',
              { required: true, pattern: /^0\d{8,9}$/ },
              t('form.error.phone'),
            ],
            [
              'email',
              t('form.email'),
              t('form.email-p'),
              'text',
              { required: true, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ },
              t('form.error.email'),
            ],
            [
              'website',
              t('form.website'),
              t('form.website-p'),
              'text',
              {
                validate: (value) =>
                  value === '' ||
                  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(
                    value
                  ),
              },
              t('form.error.website'),
            ],
            [
              'interestedCouriers',
              t('form.interested-couriers'),
              t('form.interested-couriers-placeholder'),
              'text',
              { required: true },
              t('form.error.interested-couriers'),
            ],
          ].map((field) => {
            const [name, label, placeholder, type, rules, errorText] = field
            return (
              <Grid item xs={12} sm={6} key={field[0]}>
                <Controller
                  as={
                    <TextField
                      label={label}
                      variant="outlined"
                      type={type}
                      fullWidth
                      placeholder={placeholder}
                      error={errors[name]}
                      helperText={errors[name] && errorText}
                    />
                  }
                  name={name}
                  control={control}
                  defaultValue=""
                  rules={rules}
                />
              </Grid>
            )
          })}
        </Grid>
        <div className={classes.verticalSpacer2} />
        <ProtectedByRecaptcha />
        <ButtonSp
          className={classes.button}
          style={{ marginTop: theme.spacing(1) }}
          type="submit"
          loading={isFormExecuting}
        >
          {t('form.submit')}
        </ButtonSp>
        <ReCAPTCHA
          sitekey={publicRuntimeConfig.recaptcha2Key}
          ref={recaptchaRef}
          size="invisible"
          badge="bottomleft"
        />
      </Container>
    </div>
  )

  const forDevJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'SHIPPOP Shipping Gateway API',
    serviceType: 'Shipping API integration',
    areaServed: 'TH',
    provider: { '@type': 'Organization', name: 'SHIPPOP', url: 'https://www.shippop.com' },
    url: 'https://www.shippop.com/for-developers',
    description: 'เชื่อมต่อระบบขนส่งผ่าน API ครั้งเดียวได้ถึง 20+ ขนส่งชั้นนำกับ SHIPPOP',
  }

  return (
    <div className={classes.root}>
      <Layout
        title="Developer SHIPPOP - เชื่อมที่เดียวจบ Shipping Gateway"
        keywords="API, เชื่อม api ขนส่ง, shipping gateway, เชื่อม api, ขนส่ง"
        description="เชื่อมต่อระบบของคุณกับระบบขนส่งของ SHIPPOP ผ่านระบบ API (shipping gateway) เชื่อมต่อเพียงครั้งเดียวได้ถึง 20+ ขนส่งชั้นนำ ไม่ต้องเสียเวลาอีกต่อไป"
      >
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(forDevJsonLd) }}
          />
        </Head>
        <div className={classes.page}>
          {renderHeroImageSection()}
          {renderApiSection()}
          {renderPluginSection()}
          <LazyLoad
            offset={1000}
            placeholder={<LazyloadPlaceholder />}
            once
            style={{ width: '100%' }}
          >
            <ApiCustomers
              classes={classes}
              isMobile={isMobile}
              isTablet={isTablet}
              isDesktop={isDesktop}
              t={t}
            />
          </LazyLoad>
          <a id="api-manual-section" />
          <LazyLoad
            offset={1000}
            placeholder={<LazyloadPlaceholder />}
            once
            style={{ width: '100%' }}
          >
            {renderApiManualSection()}
          </LazyLoad>
          {renderFormSection()}
          <GetStarted />
        </div>
        <ApplyResultModal
          isOpen={isSuccessModalOpen}
          setOpen={setSuccessModalOpen}
          title={tTh('form.success-modal.title')}
          subtitle={tTh('form.success-modal.subtitle', { email: submittedEmail })}
          note={tTh('form.success-modal.note')}
        />
        <SuccessModal
          type="error"
          isOpen={isErrorModalOpen}
          setOpen={setErrorModalOpen}
          title={t('form.error-modal.title')}
          subtitle={t('form.error-modal.subtitle')}
        />
        <ApplyResultModal
          type="fail"
          isOpen={isApplyFailModalOpen}
          setOpen={setApplyFailModalOpen}
          title={tTh('form.apply-fail-modal.title')}
          subtitle={tTh('form.apply-fail-modal.subtitle', {
            email: submittedEmail,
          })}
        />
        <ContactDevModal
          open={isContactDevelopModalOpen}
          setOpen={setContactDeveloperModalOpen}
        />
      </Layout>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'for-developers',
    ])),
  },
})

export default ForDeveloperPage
